<lf-form #form path="/intermediary-form" [restrictWidth]="true"
         [isReadOnly]="initialValues.mode.detail">
    <lf-alert [startVisible]="initialValues.mode.new && initialValues.loadedPrevRegistration"
              [style]="'info'" showCloseButton="true">
    <lf-i18n key="loadedPrevRegistration"></lf-i18n>
  </lf-alert>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n key="identification"></lf-i18n>
      </h1>
    </lf-panel-header>
    <lf-panel-body>
      <div class="row">
        <!-- netpVat -->
        <div class="col-xs-4">
          <div class="form-group form-group-sm">
            <lf-i18n #netpVatHlpTxt="lfI18n" class="hide" path="currVatId" [key]="'netpHelp'"></lf-i18n>
            <lf-help-label [help]="netpVatHlpTxt.translation" [hasCode]="true">
              <lf-i18n path="currVatId" key="netpVat"></lf-i18n>
            </lf-help-label>
          </div>
        </div>
        <!-- identificationOfBusiness -->
        <div class="col-xs-7 col-xs-offset-1">
          <div class="form-group form-group-sm">
            <lf-help-label>
              <lf-i18n path="identificationOfBusiness" key="label"></lf-i18n>
            </lf-help-label>
          </div>
        </div>
      </div>
      <div class="row padding-top-0">
        <lf-text class="col-xs-2" path="currVatId/issuingCountry" isReadOnly="true"></lf-text>
        <lf-text class="col-xs-2" path="currVatId/vatIdNum" isReadOnly="true"></lf-text>

        <lf-text class="col-xs-2 col-xs-offset-1" path="identificationOfBusiness/issuingCountry"
                 isReadOnly="true"></lf-text>
        <lf-text class="col-xs-2" path="identificationOfBusiness/vatIdNum" isReadOnly="true"></lf-text>
        <lf-text class="col-xs-3" *ngIf="false"
                 path="identificationOfBusiness/taxRefNum" isReadOnly="true"></lf-text>
      </div>

      <div class="row">
        <lf-text class="col-xs-9" path="companyName" [isReadOnly]="hasCadastroData"></lf-text>
      </div>

      <div class="row">
        <lf-table class="col-xs-12" path="tradingNames">
          <!-- |     Name     | -->
          <!-- Table header -->
          <lf-table-header>
            <lf-table-index-column></lf-table-index-column>
            <lf-table-column id="name"></lf-table-column>
          </lf-table-header>
          <ng-template #lfTableRowTemplate let-id="id" let-i="index">
            <tr lf-table-row [path]="id">
              <td lf-table-index-cell>{{ i + 1 }}</td>
              <td lf-table-cell>
                <lf-text path="name"></lf-text>
              </td>
            </tr>
          </ng-template>
        </lf-table>
      </div>

      <div class="row">
        <lf-select class="col-xs-6" path="countryOfBusiness" [isReadOnly]="!initialValues.isNonResident"></lf-select>
        <lf-select class="col-xs-6" path="cobRegion" [isReadOnly]="!initialValues.isNonResident"></lf-select>
      </div>

      <h2>
        <lf-i18n path="address" key="label"></lf-i18n>
      </h2>
      <lf-show [expression]="form.relativeStorage.get('./address/type') === 'structured' || hasCadastroData">
        <div class="row">
          <lf-text class="col-xs-6" path="address/street" [isReadOnly]="hasCadastroData"></lf-text>
          <lf-text class="col-xs-1" path="address/buildingNumber" [isReadOnly]="hasCadastroData"></lf-text>
          <lf-text class="col-xs-1" path="address/floorNumber" [isReadOnly]="hasCadastroData"></lf-text>
          <lf-text class="col-xs-3" path="address/postCode" [isReadOnly]="hasCadastroData"></lf-text>
          <lf-text class="col-xs-4" path="address/city" [isReadOnly]="hasCadastroData"></lf-text>
        </div>

        <!-- Extra fields -->
        <div class="row" *ngIf="initialValues.mode.detail && showExtraAddressFields(form.relativeStorage.get('./address'))">
          <lf-text class="col-xs-2" path="address/suite"></lf-text>
          <lf-text class="col-xs-2" path="address/postOfficeBox"></lf-text>
          <lf-text class="col-xs-4" path="address/district"></lf-text>
          <lf-text class="col-xs-4" path="address/countrySubEntity"></lf-text>
          <lf-text class="col-xs-6" path="address/otherLocalId"></lf-text>
        </div>
      </lf-show>
      <div class="row padding-top">
        <lf-select class="col-xs-6" path="address/country" [isReadOnly]="hasCadastroData"></lf-select>
        <lf-select class="col-xs-6" path="address/region" [isReadOnly]="hasCadastroData"></lf-select>
      </div>
      <!-- Free text address -->
      <div class="row" *ngIf="initialValues.mode.detail && form.relativeStorage.get('./address/freeText')">
        <lf-textarea class="col-xs-9" path="address/freeText"></lf-textarea>
      </div>

      <!-- More Contact Info -->
      <h2>
        <lf-i18n path="contactInfo" key="label"></lf-i18n>
      </h2>
      <div class="row">
        <lf-text class="col-xs-4" path="contactInfo/email"></lf-text>
        <lf-text *ngIf="!initialValues.mode.detail" class="col-xs-4" path="contactInfo/emailConfirmation"></lf-text>
      </div>
      <div class="row">
        <lf-text class="col-xs-4" path="contactInfo/telephone"></lf-text>
      </div>

    </lf-panel-body>
  </lf-panel>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n path="bankAccountInfo" key="label"></lf-i18n>
      </h1>
    </lf-panel-header>
    <lf-panel-body>
      <div class="row">
        <lf-text class="col-xs-4" path="bankAccountInfo/iban"></lf-text>
        <lf-text class="col-xs-2" path="bankAccountInfo/bic"></lf-text>
        <lf-text class="col-xs-6" path="bankAccountInfo/accountHolder"></lf-text>
      </div>
    </lf-panel-body>
  </lf-panel>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n key="contact"></lf-i18n>
      </h1>
    </lf-panel-header>

    <lf-panel-body>


      <h2>
        <lf-i18n path="contactName" key="label"></lf-i18n>
      </h2>

      <!-- Structured Name -->
      <lf-show *ngIf="initialValues.mode.detail" [expression]="form.relativeStorage.get('./contactName/type') === 'structured'">
        <div class="row padding-top">
          <lf-text class="col-xs-2" path="contactName/precedingTitle"></lf-text>
          <lf-text class="col-xs-3" path="contactName/firstName"></lf-text>
          <lf-text class="col-xs-2" path="contactName/lastNamePrefix"></lf-text>
          <lf-text class="col-xs-3" path="contactName/lastName"></lf-text>
          <lf-text class="col-xs-2" path="contactName/generalSuffix"></lf-text>
          <lf-text class="col-xs-4" path="contactName/maidenName"></lf-text>
        </div>
        <div class="row">
          <lf-table class="col-xs-12" path="contactName/titles">
            <!-- |     Name     | -->
            <!-- Table header -->
            <lf-table-header>
              <lf-table-index-column></lf-table-index-column>
              <lf-table-column id="name"></lf-table-column>
            </lf-table-header>
            <ng-template #lfTableRowTemplate let-id="id" let-i="index">
              <tr lf-table-row [path]="id">
                <td lf-table-index-cell>{{ i + 1 }}</td>
                <td lf-table-cell>
                  <lf-text path="name"></lf-text>
                </td>
              </tr>
            </ng-template>
          </lf-table>
        </div>
        <div class="row">
          <lf-table class="col-xs-12" path="contactName/middleNames">
            <!-- |     Name     | -->
            <!-- Table header -->
            <lf-table-header>
              <lf-table-index-column></lf-table-index-column>
              <lf-table-column id="name"></lf-table-column>
            </lf-table-header>
            <ng-template #lfTableRowTemplate let-id="id" let-i="index">
              <tr lf-table-row [path]="id">
                <td lf-table-index-cell>{{ i + 1 }}</td>
                <td lf-table-cell>
                  <lf-text path="name"></lf-text>
                </td>
              </tr>
            </ng-template>
          </lf-table>
        </div>
        <div class="row">
          <lf-table class="col-xs-12" path="contactName/generationIdentifiers">
            <!-- |     Name     | -->
            <!-- Table header -->
            <lf-table-header>
              <lf-table-index-column></lf-table-index-column>
              <lf-table-column id="name"></lf-table-column>
            </lf-table-header>
            <ng-template #lfTableRowTemplate let-id="id" let-i="index">
              <tr lf-table-row [path]="id">
                <td lf-table-index-cell>{{ i + 1 }}</td>
                <td lf-table-cell>
                  <lf-text path="name"></lf-text>
                </td>
              </tr>
            </ng-template>
          </lf-table>
        </div>
        <div class="row">
          <lf-table class="col-xs-12" path="contactName/suffixes">
            <!-- |     Name     | -->
            <!-- Table header -->
            <lf-table-header>
              <lf-table-index-column></lf-table-index-column>
              <lf-table-column id="name"></lf-table-column>
            </lf-table-header>
            <ng-template #lfTableRowTemplate let-id="id" let-i="index">
              <tr lf-table-row [path]="id">
                <td lf-table-index-cell>{{ i + 1 }}</td>
                <td lf-table-cell>
                  <lf-text path="name"></lf-text>
                </td>
              </tr>
            </ng-template>
          </lf-table>
        </div>
      </lf-show>
      <!-- Free Text Name -->
      <div class="row padding-top">
        <lf-text class="col-xs-9" path="contactName/freeText"></lf-text>
      </div>
    </lf-panel-body>
  </lf-panel>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n path="fixedEstablishments" key="label"></lf-i18n>
      </h1>
    </lf-panel-header>
    <lf-panel-body>
      <lf-table-form path="fixedEstablishments"
                     [initializationFields]="['taxIdentif']"
                     class="oss-hide-lf-label">
        <!-- Actual information of each form-table row -->
        <ng-template #lfTableFormRowTemplate let-id="id" let-row>
          <lf-table-form-row [path]="id" #tableRow>
            <h2>
              <lf-i18n key="fixedEstablishmentsVatId"></lf-i18n>
            </h2>
            <div class="row">
              <lf-select class="col-xs-3 oss-hide-clear-btn" path="taxIdentif/issuingCountry"></lf-select>
              <lf-text class="col-xs-3" path="taxIdentif/vatIdNum"></lf-text>
              <lf-text class="col-xs-3" path="taxIdentif/taxRefNum"></lf-text>
            </div>
            <div class="row">
              <lf-text class="col-xs-12" path="tradingName"></lf-text>
            </div>
            <h2>
              <lf-i18n path="address" key="label"></lf-i18n>
            </h2>
            <div class="row">
              <lf-select class="col-xs-6" path="address/country"></lf-select>
              <lf-select class="col-xs-6" path="address/region"></lf-select>
            </div>
            <!-- Structured fields -->
            <lf-show [expression]="row.address.type === 'structured'">
              <div class="row">
                <lf-text class="col-xs-6" path="address/street"></lf-text>
                <lf-text class="col-xs-1" path="address/buildingNumber"></lf-text>
                <lf-text class="col-xs-1" path="address/floorNumber"></lf-text>
                <lf-text class="col-xs-3" path="address/postCode"></lf-text>
                <lf-text class="col-xs-4" path="address/city"></lf-text>
              </div>
              <div class="row" *ngIf="initialValues.mode.detail && showExtraAddressFields(row.address)">
                <lf-text class="col-xs-2" path="address/suite"></lf-text>
                <lf-text class="col-xs-2" path="address/postOfficeBox"></lf-text>
                <lf-text class="col-xs-4" path="address/district"></lf-text>
                <lf-text class="col-xs-4" path="address/countrySubEntity"></lf-text>
                <lf-text class="col-xs-6" path="address/otherLocalId"></lf-text>
              </div>
            </lf-show>
            <!-- Free text address -->
            <div class="row padding-top" *ngIf="row.address.freeText">
              <lf-textarea class="col-xs-9" path="address/freeText"></lf-textarea>
            </div>
          </lf-table-form-row>
        </ng-template>
        <!-- A subset of the fields in `#lfTableFormRowTemplate` without
                   the schema related stuff has to be used (NOTE: this API will
                   likely change with the next version of LF) -->
        <ng-template #lfTableFormRowInitializer let-id="id">
          <lf-table-form-row [path]="id">
            <!-- Will use the schemas defined above (since the `name` is
                 the same) -->
            <lf-select path="taxIdentif/issuingCountry"></lf-select>
            <lf-text path="taxIdentif/vatIdNum"></lf-text>
            <lf-text path="taxIdentif/taxRefNum"></lf-text>
          </lf-table-form-row>
        </ng-template>
      </lf-table-form>
    </lf-panel-body>
  </lf-panel>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n path="prevOrCurrOssVatId" key="headerText"></lf-i18n>
      </h1>
      <h4>
        <lf-i18n path="prevOrCurrOssVatId" key="subHeaderText"></lf-i18n>
      </h4>
    </lf-panel-header>
    <lf-panel-body>
      <lf-table path="prevOrCurrOssVatId">
        <!-- |     IssuingCountry     |     VatIdNum     | -->
        <!-- Table header -->
        <lf-table-header>
          <lf-table-index-column></lf-table-index-column>
          <lf-table-column id="issuingCountry"></lf-table-column>
          <lf-table-column id="vatIdNum"></lf-table-column>
        </lf-table-header>
        <ng-template #lfTableRowTemplate let-id="id" let-i="index">
          <tr lf-table-row [path]="id">
            <td lf-table-index-cell>{{ i + 1 }}</td>
            <td lf-table-cell>
              <lf-select path="issuingCountry"></lf-select>
            </td>
            <td lf-table-cell>
              <lf-text path="vatIdNum"></lf-text>
            </td>
          </tr>
        </ng-template>
      </lf-table>
    </lf-panel-body>
  </lf-panel>

  <lf-panel>
    <lf-panel-header>
      <h1>
        <lf-i18n path="relevantDates" key="label"></lf-i18n>
      </h1>
    </lf-panel-header>
    <lf-panel-body>
      <div class="row">
        <lf-date class="col-xs-4" isReadOnly="true" path="relevantDates/registrationReqDate"></lf-date>
        <lf-date class="col-xs-4" *ngIf="form.relativeStorage.get('relevantDates/msidDecisionDate')"
                 isReadOnly="true" path="relevantDates/msidDecisionDate"></lf-date>
      </div>
    </lf-panel-body>
  </lf-panel>

</lf-form>
